// GENERATED by tools/gen_visual_overlays.mjs -- do not edit.
// Scenes whose data/pixel_scenes/<dir>/<name>_visual.png carries the engine's
// per-pixel cell-color override art (LoadPixelScene's colors file).
export const VISUAL_OVERLAY_SCENES = new Set([
	"coalmine/altar",
	"coalmine/carthill",
	"coalmine/coalpit01",
	"coalmine/coalpit02",
	"coalmine/coalpit03",
	"coalmine/coalpit04",
	"coalmine/coalpit05",
	"coalmine/laboratory",
	"coalmine/oiltank_1",
	"coalmine/oiltank_2",
	"coalmine/oiltank_3",
	"coalmine/oiltank_4",
	"coalmine/oiltank_alt",
	"coalmine/oiltank_puzzle",
	"coalmine/physics_01",
	"coalmine/physics_02",
	"coalmine/physics_swing_puzzle",
	"coalmine/receptacle_oil",
	"coalmine/shop",
	"coalmine/shrine01",
	"coalmine/shrine02",
	"coalmine/slimepit",
	"coalmine/swarm",
	"coalmine/wandtrap_h_01",
	"coalmine/wandtrap_h_02",
	"coalmine/wandtrap_h_03",
	"coalmine/wandtrap_h_04",
	"coalmine/wandtrap_h_05",
	"coalmine/wandtrap_h_06",
	"crypt/beam_01",
	"crypt/beam_02",
	"crypt/beam_03",
	"crypt/beam_04",
	"crypt/beam_05",
	"crypt/beam_06",
	"crypt/beam_07",
	"crypt/beam_08",
	"crypt/cavein_01",
	"crypt/cavein_03",
	"crypt/cavein_04",
	"crypt/lavaroom",
	"crypt/pit",
	"crypt/room_gate_drop",
	"crypt/room_liquid_funnel",
	"crypt/shop",
	"crypt/water_lava",
	"excavationsite/cube_chamber",
	"excavationsite/gunpowderpool_01",
	"excavationsite/gunpowderpool_02",
	"excavationsite/gunpowderpool_03",
	"excavationsite/gunpowderpool_04",
	"excavationsite/machine_1",
	"excavationsite/machine_2",
	"excavationsite/machine_3",
	"excavationsite/machine_3b",
	"excavationsite/machine_4",
	"excavationsite/machine_5",
	"excavationsite/machine_6",
	"excavationsite/meditation_cube",
	"excavationsite/oiltank_1",
	"excavationsite/puzzleroom_02",
	"excavationsite/puzzleroom_03",
	"excavationsite/shop",
	"general/acidtank",
	"general/acidtank_2",
	"general/alchemist_secret",
	"general/alchemist_secret_music",
	"general/altar",
	"general/boss_victoryroom",
	"general/bunker",
	"general/dragoncave",
	"general/essenceroom",
	"general/eyespot",
	"general/fishing_hut",
	"general/huussi",
	"general/null_room",
	"general/orbroom",
	"general/physics_tank",
	"general/potion_altar",
	"general/potion_altar_vault",
	"general/robot_egg",
	"general/secret_lab",
	"general/tank_liquid_3",
	"general/tank_liquid_4",
	"general/wand_altar",
	"general/wand_altar_vault",
	"general/wizardcave_entrance",
	"liquidcave/container_01",
	"mountain/floating_island",
	"mountain/hall",
	"mountain/hall_b",
	"mountain/hall_br",
	"mountain/hall_r",
	"mountain/left",
	"mountain/left_2",
	"mountain/left_3",
	"mountain/left_entrance",
	"mountain/right",
	"mountain/right_entrance",
	"mountain/right_entrance_2",
	"overworld/cliff",
	"overworld/desert_ruins_base_01",
	"overworld/desert_ruins_base_02",
	"overworld/desert_ruins_base_03",
	"overworld/desert_ruins_block_01",
	"overworld/desert_ruins_block_02",
	"overworld/desert_ruins_block_03",
	"overworld/desert_ruins_block_04",
	"overworld/desert_ruins_block_05",
	"overworld/desert_ruins_block_06",
	"overworld/desert_ruins_block_07",
	"overworld/desert_ruins_block_08",
	"overworld/essence_altar",
	"overworld/essence_altar_desert",
	"overworld/music_machine_stand",
	"overworld/snowy_rock_01",
	"overworld/snowy_rock_02",
	"overworld/snowy_rock_03",
	"overworld/snowy_rock_04",
	"overworld/snowy_rock_05",
	"overworld/snowy_ruins_base_01",
	"overworld/snowy_ruins_base_02",
	"overworld/snowy_ruins_base_03",
	"overworld/snowy_ruins_eye_pillar",
	"overworld/snowy_ruins_pillar_01",
	"overworld/snowy_ruins_pillar_02",
	"overworld/snowy_ruins_pillar_03",
	"overworld/snowy_ruins_pillar_04",
	"overworld/snowy_ruins_pillar_05",
	"pyramid/entrance",
	"pyramid/hallway",
	"pyramid/reward",
	"pyramid/top",
	"rainforest/oiltank_01",
	"rainforest/rainforest_statue_01",
	"rainforest/rainforest_statue_02",
	"rainforest_dark/oiltank_01",
	"rainforest_dark/rainforest_statue_01",
	"rainforest_dark/rainforest_statue_02",
	"rainforest_open/oiltank_01",
	"rainforest_open/rainforest_statue_01",
	"rainforest_open/rainforest_statue_02",
	"snowcastle/bar",
	"snowcastle/drill",
	"snowcastle/forge",
	"snowcastle/greenhouse",
	"snowcastle/sauna",
	"snowcastle/shaft",
	"snowcastle/side_cavern_left",
	"snowcastle/side_cavern_right",
	"snowcave/acidtank",
	"snowcave/acidtank_2",
	"snowcave/buried_eye",
	"snowcave/crater",
	"snowcave/horizontalobservatory",
	"snowcave/horizontalobservatory2",
	"snowcave/horizontalobservatory3",
	"snowcave/pipe",
	"snowcave/puzzle_capsule",
	"snowcave/puzzle_capsule_b",
	"snowcave/secret_chamber",
	"snowcave/shop",
	"snowcave/snowcastle",
	"snowcave/tinyobservatory",
	"snowcave/tinyobservatory2",
	"snowcave/verticalobservatory",
	"snowcave/verticalobservatory2",
	"spliced/boss_arena",
	"spliced/moon",
	"spliced/moon_dark",
	"spliced/skull",
	"spliced/skull_in_desert",
	"spliced/tree",
	"temple/altar",
	"temple/altar_empty",
	"temple/altar_left",
	"temple/altar_right",
	"temple/altar_top",
	"vault/acidtank",
	"vault/brain_room",
	"vault/entrance",
	"vault/lab",
	"vault/lab2",
	"vault/lab3",
	"vault/lab_puzzle",
	"vault/pipe_big_hor_1",
	"vault/pipe_big_hor_2",
	"vault/pipe_big_turn_left",
	"vault/pipe_big_turn_right",
	"vault/pipe_big_ver_1",
	"vault/pipe_big_ver_2",
	"vault/pipe_cross",
	"vault/pipe_hor_1",
	"vault/pipe_hor_2",
	"vault/pipe_hor_3",
	"vault/pipe_turn_left",
	"vault/pipe_turn_right",
	"vault/pipe_ver_1",
	"vault/pipe_ver_2",
	"vault/pipe_ver_3",
	"vault/pipe_ver_4",
	"vault/shop"
]);
